import $ from "jquery";
import 'jquery-validation';
import 'owl.carousel';
import Swal from 'sweetalert2'
var windowsize = $(window).width();

$(function () {
  $('#list-gallery').owlCarousel({
    autoplay: true,
    margin: 20,
    items: 3,
    responsiveClass: true,
    autoHeight: true,
    autoplayTimeout: 7000,
    smartSpeed: 800,
    dots: false,
    responsive: {
      0: {
        items: 1
      },

      300: {
        items: 1
      },

      768: {
        items: 1
      },

      1000: {
        items: 1
      },
    }
  });

  $('#list-voucher').owlCarousel({
    autoplay: true,
    margin: 20,
    items: 3,
    responsiveClass: true,
    autoHeight: true,
    autoplayTimeout: 7000,
    smartSpeed: 800,
    dots: false,
    responsive: {
      0: {
        items: 1
      },

      300: {
        items: 1
      },

      768: {
        items: 1
      },

      1000: {
        items: 1
      },
    }
  });
});

$(window).on("load", function () {
  // Hide all tab content except the first
  $('.tabContent').not(':first').hide();


  // xử lý khi lộ trình học là tab
  $('.tabs a').click(function () {

    //Hide all tab content
    $('.tabContent').hide();

    // Remove active class from all tabs links
    $('.tabs a').removeClass('active');

    // Add active class to clicked tab link
    $(this).addClass('active');

    // Get data-tab attribute value
    var tab = $(this).data('tab');

    // Show corresponding tab content
    $('.' + tab).show();
  });

  // xử lý khi lộ trình học là accordion
  $(".tab_drawer_heading").click(function () {
    if ($(this).hasClass("d_active")) {
      $(".tabContent").hide();
      $(".tab_drawer_heading").removeClass("d_active");
      return;
    }
    $(".tabContent").hide();
    let activeTab = $(this).attr("rel");
    $("#" + activeTab).fadeIn();
    $(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");
    $(this).get(0).scrollIntoView({ behavior: 'smooth' });
    $("ul.tabs li").removeClass("active");
    $("ul.tabs li[rel^='" + activeTab + "']").addClass("active");
  });

  $('.download-register-document').on('click', function () {
    $(".offer-join").get(0).scrollIntoView({ behavior: 'smooth' });
  })

  let form1 = $('.offer-join-form1')
  let form2 = $('.offer-join-form2')
  const option = {
    rules: {
      "name": {
        required: true,
        maxlength: 255
      },
      "phone": {
        required: true,
        maxlength: 20
      },
      "email": {
        required: true,
        email: true
      },
      "course": {
        required: true,
        number: true,
      },
    },
    messages: {
      "name": {
        required: "Vui lòng nhập họ tên",
        maxlength: "Họ tên không hợp lệ"
      },
      "email": {
        required: "Vui lòng nhập nhập email",
        email: "Email không hợp lệ"
      },
      "phone": {
        required: "Vui lòng nhập nhập số điện thoại",
        maxlength: "Số điện thoại không hợp lệ"
      },
      "course": {
        required: "Vui lòng chọn khóa học",
      },
    },
    submitHandler: function () {
      let url = $('.btn-register').data('url');
      let currentForm = $(this.currentForm)
      let data = {
        'name': currentForm.find('input[name="name"]').val(),
        'phone': currentForm.find('input[name="phone"]').val(),
        'email': currentForm.find('input[name="email"]').val(),
        'course': currentForm.find('select[name="course"]').val(),
        'note': currentForm.find('textarea[name="note"]').val()
      };
      $.ajax({
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
        data: data,
        type: "POST",
        url: url,
        success: function (response) {
          if (response.status == true) {
            currentForm.find('input').val("");
            currentForm.find('textarea').val("");
            currentForm.find('option:selected').remove();
            currentForm.find('.alert-success').show();
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Đăng ký thành công',
              showConfirmButton: false,
              timer: 2000
            })
          }
        },
      });
    }
  }
  form1.validate(option);
  form2.validate(option);
  $(document).on('click', '.btn-register', function () {
    form1.find('.alert-success').hide();
  });

  removeBrTag();
})

//Remove tag name br in section Why Learn - Heading
function removeBrTag() {
  windowsize = $(window).width();
  if (windowsize < 768) {
    jQuery(".why-learn-item .why-learn-item-stt h3").find('br').remove();
  }
}

function initSlideListTeacher() {
  var slideListTeacher = $('.teacher-list-wrapper');
  if (windowsize < 1200) {
    slideListTeacher.owlCarousel({
      items: 1,
      center: false,
      loop: true,
      margin: 0,
      nav: false,
      autoplay: true,
      autoplayTimeout: 2000,
      autoplayHoverPause: true,
      dots: false,
      responsive: {
        576: {
          items: 1
        },
        768: {
          items: 2
        },
        1200: {
          items: 2
        }
      },
    });
  } else {
    slideListTeacher.owlCarousel('destroy');
  }
}

$(window).resize(function () {
  removeBrTag();
  initSlideListTeacher();
});

$(document).ready(function () {
  removeBrTag();
  initSlideListTeacher();
});
$(document).ready(function () {
  let gridLayout = $(".grid-layout");
  let owlCarousel = $(".list-gallery-carousel");

  // Function to switch to the Owl Carousel
  function switchToCarousel() {
    gridLayout.hide(); // Hide the grid
    owlCarousel.show(); // Show the Owl Carousel
  }

  // Function to switch back to the grid layout
  function switchToGrid() {
    owlCarousel.hide(); // Hide the Owl Carousel
    gridLayout.show(); // Show the grid layout
  }

  // Check window width and switch to the Owl Carousel when responsive
  function toggleLayout() {
    if ($(window).width() < 768) {
      switchToCarousel();
    } else {
      switchToGrid();
    }
  }

  // Initial call and window resize event listener
  toggleLayout();
  $(window).resize(toggleLayout);
});
